import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';
import App from './App';
import IndexUtil from './database/lib/IndexUtil';
import ItemUtil from './database/lib/ItemUtil';
import './index.css';
import { loadSiteData } from './siteData';

const container = document.getElementById('root');
if (container === null) {
    throw new Error('Root container #root was not found in the document.');
}

// The converted XOOPS data is served with static-contents/, so it is fetched
// before the first render. Components can then read it synchronously.
loadSiteData()
    .then((data) => {
        IndexUtil.init(data.tree);
        ItemUtil.initSimpfLinks(data.simpfLinks);
        createRoot(container).render(
            <StrictMode>
                <App />
            </StrictMode>
        );
    })
    .catch((error: unknown) => {
        console.error('failed to load the site data', error);
        container.textContent = 'Failed to load the site data.';
    });
